import { Outlet } from 'react-router-dom';
import { CartDrawer } from '@/components/CartDrawer/CartDrawer';
import { Toast } from '@/components/Toast/Toast';
import { AnnouncementBar } from './AnnouncementBar';
import { CatalogStatus } from './CatalogStatus';
import { Header } from './Header';
import { Footer } from './Footer';
import styles from './Layout.module.css';

/** App shell: every route renders inside this. */
export function Layout() {
  return (
    <div className={styles.shell}>
      <AnnouncementBar />
      <Header />
      <main className={styles.main}>
        <CatalogStatus />
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <Toast />
    </div>
  );
}
